import { render } from "./slide31.vue?vue&type=template&id=2adbcf73&scoped=true"
import script from "./slide31.vue?vue&type=script&lang=js"
export * from "./slide31.vue?vue&type=script&lang=js"

import "./slide31.vue?vue&type=style&index=0&id=2adbcf73&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adbcf73"]])

export default __exports__